module.exports = __webpack_public_path__ + "img/cut@2x.fb35882.png";